<template>
    <div class="map-content">
        <transition name="component-fade" mode="out-in"  v-on:after-enter="afterEnter">
                <map-info v-show="more === 0" ref="mapInfo" @getMore="getMore" @clickPowerStation="getStationData"></map-info>
        </transition>
        <transition name="component-fade" mode="out-in" >
            <station-info  v-show="more === 1" @getBack="getMore"></station-info>
        </transition>
        <transition name="component-fade" mode="out-in" >
            <div class="station-monitor dark" v-show="more === 2">
                <station-monitor :back="true"  ref="stationMonitor" :theme="'dark'"></station-monitor>
            </div>
        </transition>
    </div>

</template>

<script>
    import Bus from "@/utils/bus";
    import mapInfo from "@/views/components/smartmonitor/mapInfo";
    import stationInfo from "@/views/components/smartmonitor/stationInfo/stationInfo";
    import stationMonitor from "@/views/components/stationMonitor/stationMonitor";
    export default {
        name: "smartmonitor",
        components:{
            mapInfo,
            stationInfo,
            stationMonitor
        },
        data(){
            return {
                more: 0
            }
        },
        mounted() {
            Bus.$on("smartMonitor", () => {
                this.getMore(0)
            });
        },
        methods:{
            afterEnter: function (el) {
                Bus.$emit("echarts-resize");
            },
            getMore(data){
                this.more = data;
                Bus.$emit("echarts-resize");
            },
            async getStationData(data){
                this.more = 2;
                //let result = await this.$http.get(this.$baseURL.findStationDataById(id))
                //result.id = result.powerStationId;
                data.powerStationName = data.name;
                this.$refs.stationMonitor.init(data);
            }

        }
    }
</script>

<style lang="less" scoped>
    .map-content{
        height: 100%;
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .5s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active for below version 2.1.8 */ {
        opacity: 0;
    }

    .station-monitor{
        height: 100%;
        padding: 10px;
        background: url('../../../../public/bg.jpg');
        background-size: 100% 100%;
        color: #eee;
        overflow-y: auto;
    }


</style>
